export default "__VITE_ASSET__gKGrCzOI__"